import axios from "../core/https";
import { ICollection } from "../core/models/collection";

const getDetail = (id: string) =>
  axios.get<ICollection>(`/marketplace/collections/${id}`, {
    headers: {
      requireToken: "0",
    },
  });

const getCollections = () =>
  axios.get<ICollection[]>(`/marketplace/collections`, {
    headers: {
      requireToken: "0",
    },
  });

const getCollectionsByAccount = (id: string, params?: { contract_type?: string }) =>
  axios.get<ICollection[]>(`/marketplace/collections/by-account/${id}`, {
    headers: {
      requireToken: "0",
    },
    params,
  });

const create = (body: {
  token_address: string;
  contract_type: string;
  owner_of?: string | null;
  meta_data: { image?: string; description?: string; cover?: string };
}) => axios.post<ICollection>(`/marketplace/collections`, body);

export const collectionService = {
  getDetail,
  getCollections,
  getCollectionsByAccount,
  create,
};
